import React from "react"
import { FaDownload, FaTruck } from "react-icons/fa"
import { Wrapper } from "./style"

const ChasisCompatibles = ({ data }) => {
  if (!data || data.length === 0) return null

  return (
    <Wrapper>
      <div className="container">
        <h2>CHASIS(ES) COMPATIBLE(S)</h2>
      </div>
      <div className="card container">
        {data.map((item, key) => (
          <div className="row" key={key}>
            <div className="row__brand">
              <span className="brand__name">{item.brand}</span>
              <span className="brand__model">{item.model}</span>
            </div>
            <div className="row__icon">
              <FaTruck />
            </div>
            <a
              className="btn-dark-outline"
              href={item.pdf}
              target="_blank"
              rel="noopener noreferrer"
              download
            >
              <FaDownload /> Ficha T&eacute;cnica
            </a>
          </div>
        ))}
      </div>
    </Wrapper>
  )
}

export default ChasisCompatibles
